module.exports = __webpack_public_path__ + "img/cornerstone-bible-church-logo1-1024x1024-1.b6fb6959.png";